import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import Image from '../../assets/img/service/service-2-1.jpg';

const SingleServiceFour = (props) => {
  const { itemClass, serviceImage, icon, title, description, btnText } = props;
  return (
    <div className={itemClass ? itemClass : 'it-service-2-item item-style-2'}>
      <div className="it-service-2-thumb">
        <img src={serviceImage ? serviceImage : Image} alt="" />
      </div>
      <div className="it-service-2-content p-relative">
        <div className="it-service-2-icon">
          <span>
            <i className={icon ? icon : 'flaticon-kiss'}></i>
          </span>
        </div>
        <h4 className="it-service-title mb-15">
          <Link className="hover-anim green" to="/service-details">
            {title ? title : 'Dating & Relation'}
          </Link>
        </h4>
        <p className="mb-20">
          {description
            ? description
            : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'}
        </p>
        <Link className="it-btn-theme service-btn" to="/service-details">
          <Button btnText={btnText ? btnText : 'Our Counseling'} />
        </Link>
      </div>
    </div>
  );
};

export default SingleServiceFour;
